import Cookies from 'js-cookie';

const V3_EXPERIENCE_COOKIE = 'v3_experience';
const V3_EXPERIENCE_VALUE = 'v3';

const cookieDomain = globalThis.env.VITE_COOKIE_DOMAIN;
const rootDomain = cookieDomain ? '.' + cookieDomain : '.' + location.hostname.split('.').slice(1).join('.');

export const V3CookieService = {
  // Returns true when the shared V3 session cookie is present with the expected value.
  // The legacy app owns setting this cookie; the frontend only reads and clears it.
  hasV3Experience(): boolean {
    return Cookies.get(V3_EXPERIENCE_COOKIE) === V3_EXPERIENCE_VALUE;
  },

  clearV3Experience(): void {
    Cookies.remove(V3_EXPERIENCE_COOKIE, { domain: rootDomain, path: '/' });
  },
};
